import { gql } from '@apollo/client';

/**
 * Fragment canónico de Accident — superset de los subselects usados por las
 * mutations legacy (CREATE_NEW_ACCIDENT, UPDATE_ACCIDENT_ORDER,
 * UPDATE_ACCIDENT_ORDER_RELATIONSHIPS).
 *
 * Se usa en la respuesta de `SAVE_ACCIDENT`. Ver PLAN-SAVE-ENTITY-UNIFIED.md §2.4.
 */
export const NEW_ACCIDENT = gql`
  fragment NewAccident on Accident {
    id

    # ─── Índices + estado ───
    indexExpedition
    indexType
    state

    # ─── Tipo B denormalizado (coherente con Order paralela) ───
    concessionIDs
    roadIDs
    teamIDs
    pkInitKm
    pkInitMeter
    pkEndKm
    pkEndMeter
    track
    direction
    margin
    lane
    creationDate
    registerInitDate

    # ─── Nav Trabajo/Revisión — contenedor D0 denormalizado (Fase 4 nav,
    # follow-up T4 2026-07-12): "Origen" de la tabla global de Accidentes se
    # lee directo de este campo, sin lookup client-side por fila. Ver
    # gql/selectors/accidents.ts → selectAccidentOrders.
    containerType

    # ─── Tipo C exclusivos Accident ───
    damages
    laneCutting
    # Corte de carril EFECTIVO calculado por el backend (flag OR actividad OR
    # OT predefinida). Es lo que se PINTA. Puede venir null en una fila creada
    # o editada sin cobertura: el selector cae entonces al cálculo local.
    isLaneCut
    policeReport
    policeReportNumber
    roadConditionDescription

    # ─── Relaciones M:N (gestionadas con UPDATE_ACCIDENT_RELATIONSHIPS) ───
    attentionAccidentIDs
    surveillanceBodyIDs
    mediumKnowledgeIDs
    weatherIDs
    surfaceConditionIDs
    luminosityIDs
    conditionsDrivingIDs

    # ─── Entidad doble ───
    orderIDs
  }
`;
